<style>
  button {
    margin: 0.2em 0.6em 0.1em 0.2em; /* top | right | bottom | left */
    background-color: transparent;
    color: #000;
    box-shadow: none;
    text-decoration: underline;
  }
  input, label {
    margin: 0.2em;
    cursor: pointer;
  }
  p {
    margin-right: 0em;
  }
  .contents {
    margin: 0em 0.6em 0.4em 0.6em; /* top | right | bottom | left */
  }
  .item {
    margin: 0.2em;
    align-items: center;
  }
  .widget {
    margin: 0.2em;
  }
  .map {
    margin: 0.4em;
    height: 30em;
  }
</style>

<script>
  import { onMount } from 'svelte';
  import config from '../../config';
  import {
    config_values,
    dev,
    leaflet_map,
    marker_data,
    open_config_widget,
  } from '../store';
  
  import 'leaflet/dist/leaflet-src';
  import 'leaflet/dist/leaflet.css';
  
  function toggle_open_config_widget() {
    if ($open_config_widget === widget_id) {
      $open_config_widget = '';
    } else {
      $open_config_widget = widget_id;
    };
  }
  
  function add_location(event) {
    let coords = [
      Math.round(event.latlng.lat*10000)/10000,
      Math.round(event.latlng.lng*10000)/10000,
    ];
    let loc_name = window.prompt(
      'Uzrakstiet vietas nosaukumu',
      `Vieta (${coords[0]}, ${coords[1]})`
    );
    if (!loc_name) {
      return;
    }
    if ($config_values.location[loc_name]) {
      window.alert('Tāda vieta jau eksistē!');
      return;
    }
    let loc_id = `${Math.round(coords[1]*10)*10}-${Math.round(coords[0]*20)*5}`;
    if (dev) {console.log(coords);}
    if (dev) {console.log(loc_id);}
    let marker = L.marker(coords).addTo($leaflet_map);
    marker.bindTooltip(`<b>${loc_name}</b>`);
    $config_values.location[loc_name] = {
      name: loc_name,
      coords: coords,
      id: loc_id,
      visible: true,
    };
    $marker_data[loc_name] = marker;
  }
  
  function remove_location(loc_name) {
    let result = window.confirm(`Vai tiešām dzēst vietu ${loc_name}?`);
    if (result) {
      if (dev) {console.log(loc_name);}
      $marker_data[loc_name].remove();
      delete $marker_data[loc_name];
      delete $config_values.location[loc_name];
      $config_values.location = $config_values.location;
    }
  }
  
  onMount(() => {
    let map = L.map('map', {
      attributionControl: false,
      center: [56.9, 24.55],
      zoom: 7,
      zoomControl: false,
    });
    $leaflet_map = map;
    
    // controls
    let attrib = L.control.attribution({
      position: 'bottomright',
      prefix: '',
    }).addTo(map);
    
    let zoom = L.control.zoom({
      position: 'topright'
    }).addTo(map);
    
    L.tileLayer(
      config.basemap_url,
      {
        attribution: config.basemap_attrib,
        maxZoom: 11,
        tileid: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        token: config.basemap_token,
      }
    ).addTo(map);
    
    for (let loc_name of Object.keys($config_values.location)) {
      let loc_coords = $config_values.location[loc_name].coords;
      let marker = L.marker(loc_coords).addTo(map);
      marker.bindTooltip(`<b>${loc_name}</b>`);
      $marker_data[loc_name] = marker;
    }

    map.on('click', add_location);
  });
  
  let params = config.config_widgets.location;
  if (!$config_values.location) {
    $config_values.location = params.default;
  }
</script>

<div class='widget vertical show-border'>
  {#if params.togglable}
    <div class='caption-center horiz-always togglable unselectable' on:click={toggle_open_config_widget}>
      <p>{params.caption}</p>
      <!-- <div class='filler'></div> -->
      {#if $open_config_widget === widget_id}
        <p class='small'>[–]</p>
      {:else}
        <p class='small'>[+]</p>
      {/if}
    </div>
  {:else}
    <div class='caption-center horiz-always unselectable'>
      <p>{params.caption}</p>
    </div>
  {/if}
  {#if !params.togglable || $open_config_widget === widget_id}
    <p>Noklikšķiniet uz kartes lai pievienot jaunu vietu</p>
    <div class='map' id='map'></div>
    <div class='contents horiz-wrap'>
      {#each Object.keys($config_values.location).sort() as loc_name}
        <div class='item horiz-always'>
          <input type='checkbox' id={loc_name} bind:checked={$config_values.location[loc_name].visible}>
          <label for={loc_name}>{loc_name}</label>
          <button class='small' id={loc_name} on:click={(function () {remove_location(loc_name)})}>Dzēst</button>
        </div>
      {/each}
    </div>
  {/if}
</div>
